export const resetPasswordRoute = {
  path: '/reset-password',
  tokenParam: 'token'
}
